<template>
    <div class="catalog">
        <top-catalog-item :category="category" v-for="category in categories" :key="category.category.id" :base-path="basePath" />
    </div>
</template>

<script>
    import TopCatalogItem from "./TopCatalogItem";
    export default {
        name: 'TopCatalog',
        components: {TopCatalogItem},
        props: ['categories', 'basePath']
    }
</script>

<style scoped>

</style>
